import { Box, Collapse, IconButton, Paper, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import { useParams } from "@tanstack/react-router"
import type { ReactElement } from "react"
import { useState } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { CommentParentTableType } from "@/graphql/codegen/graphql"

export const ProductComments = (): ReactElement => {
  const [expanded, setExpanded] = useState(true)
  const { productId } = useParams({
    from: "/app/product/$productId/edit",
  })

  return (
    <Paper className='border border-gray-300 p-6' elevation={0}>
      <Box className='flex items-center justify-between'>
        <Typography variant='h6' className={expanded ? "mb-6" : ""}>
          Comments
        </Typography>
        <IconButton onClick={() => setExpanded(!expanded)} aria-expanded={expanded} aria-label='show more'>
          {expanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <CommentsSection type={CommentParentTableType.Product} referenceId={productId} />
      </Collapse>
    </Paper>
  )
}
